'use client'
import { bsc } from '@reown/appkit/networks'
import { createAppKit } from '@reown/appkit/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'jotai'
import { type ReactNode } from 'react'
import { type Config, cookieToInitialState, WagmiProvider } from 'wagmi'

import { networks, projectId, wagmiAdapter } from '@/config'
import { globalStore } from '@/stores/global'

import LoginContext from './login-context'

const queryClient = new QueryClient()

const metadata = {
  name: 'next-reown-appkit',
  description: 'next-reown-appkit',
  url: 'https://gata-chat-test.vercel.app/chat',
  icons: ['https://avatars.githubusercontent.com/u/179229932'],
}

export const modal = createAppKit({
  adapters: [wagmiAdapter],
  projectId,
  networks: [bsc, ...networks],
  defaultNetwork: bsc,
  metadata,
  coinbasePreference: 'eoaOnly',
  defaultAccountTypes: { eip155: 'eoa' },
  enableCoinbase: true,
  themeMode: 'light',
  features: {
    analytics: true,
    email: false,
    socials: false,
  },
  themeVariables: {
    '--w3m-accent': '#000000',
  },
})

function ContextProvider({ children, cookies }: { children: ReactNode; cookies: string | null }) {
  const initialState = cookieToInitialState(wagmiAdapter.wagmiConfig as Config, cookies)

  return (
    <Provider store={globalStore}>
      <WagmiProvider config={wagmiAdapter.wagmiConfig as Config} initialState={initialState}>
        <QueryClientProvider client={queryClient}>
          <LoginContext>{children}</LoginContext>
        </QueryClientProvider>
      </WagmiProvider>
    </Provider>
  )
}

export default ContextProvider
